import type { HTMLAttributes } from 'react';

export const HEADER_AREA = 'header' as const;
export const BODY_AREA = 'body' as const;
export const FOOTER_AREA = 'footer' as const;

export type ShowBorderProp = { $showBorder?: boolean };

export type IntrinsicAttributes<T extends Element = HTMLElement> =
    HTMLAttributes<T> & Record<`data-${string}`, unknown>;
